module.exports = "<ngx-dialog-wrapper [config]=\"wrapperConfig\" (btnClick)=\"phbBtnClicked($event)\" #dialogWrapper>\r\n    <div class=\"info-text\" [innerHTML]=\"infoText\">\r\n    </div>\r\n    <fw-dynamic-grid\r\n        #grid class=\"grid\"\r\n        [vmColumnDefinition]=\"cdAppointments\"\r\n        [rowKey]=\"'id'\">\r\n    </fw-dynamic-grid>\r\n</ngx-dialog-wrapper>\r\n";


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/shared/appointment-list.component.html
// module id = 2464
// module chunks = 1